import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useParams, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

function Component(): React.JSX.Element {
  const { t } = useTranslation();
  const params = useParams({ from: "/__public/return-reset-password/$state" });

  if (params.state === "update_success")
    return (
      <section>
        <Stack gap={3}>
          <Typography color="success.main" variant="h4">
            {t("resetPassword.successTitle")}
          </Typography>
          <Typography>{t("resetPassword.keepPassword")}</Typography>
          <Box style={{ width: "100%" }} textAlign="center">
            <Button fullWidth href="/login" size="large" variant="contained">
              {t("resetPassword.enterPortal")}
            </Button>
          </Box>
        </Stack>
      </section>
    );

  return (
    <section>
      <Stack gap={3}>
        <Typography color="warning.main" variant="h4">
          {t("resetPassword.expiredTitle")}
        </Typography>
        <Typography>{t("resetPassword.expiredMessage")}</Typography>
        <Typography>{t("resetPassword.requestNewLink")}</Typography>
        <Box textAlign="center">
          <Button href="/forgot-password" size="large" variant="contained">
            {t("forgotPassword.title")}
          </Button>
        </Box>
      </Stack>
    </section>
  );
}

export const Route = createFileRoute("/__public/return-reset-password/$state")({
  component: Component,
});
